import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLikelihood = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 2C8.44444 3.77778 9.33333 5.22222 10.6667 6.33333C12 7.44444 12.6667 8.66667 12.6667 10C12.6667 11.2377 12.175 12.4247 11.2998 13.2998C10.4247 14.175 9.23768 14.6667 8 14.6667C6.76232 14.6667 5.57534 14.175 4.70017 13.2998C3.825 12.4247 3.33333 11.2377 3.33333 10C3.33333 9.27877 3.56726 8.57699 4 8C4 8.44203 4.17559 8.86595 4.48816 9.17851C4.80072 9.49107 5.22464 9.66667 5.66667 9.66667C6.10869 9.66667 6.53262 9.49107 6.84518 9.17851C7.15774 8.86595 7.33333 8.44203 7.33333 8C7.33333 6.66667 6.33333 6 6.33333 4.66667C6.33333 3.77778 6.88889 2.88889 8 2Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLikelihood;
